import { Component } from 'react';
import { Redirect } from 'react-router-dom';

/*
 withErrorBoundary HOC handles errors and crash in wrapped components 
 and their children. 
 On error : redirect to /Dashboard
*/
function withErrorBoundary(WrappedComponent){
  return class ErrorBoundary extends Component {
    state = { hasError: false }

    componentDidCatch(error, info) {
      this.setState({ hasError: true });
      console.log([error, info]);
    }

    render() {
      const returnComponent = (this.state.hasError) ? 
        <Redirect to="/" /> : 
        <WrappedComponent {...this.props} />;
      return returnComponent;
    }
  }
}

export default withErrorBoundary;
